import { run as runActions } from '../../../../../store/workspaces/workspaces/run';

export const onSlide = (index, navData, actionsState, imageData) => {

  const onClickEventKey = navData.widgetData.events.find(event => event.type === 'onClick')?.key ?? null;

  if (onClickEventKey !== null) {
    runActions(onClickEventKey, imageData[index]?.id, actionsState);
  }
};